/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { formatedSelectOption, omitEmptyArgs, customStyle } from 'helper';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  actual_use_id: '',
  assessment_level: '',
  ordinance_revision_id: '',
};

function AssessmentLevelModal({
  getActualUseList,
  actualUseList,
  createAssessmentLevel,
  type,
  assessmentLevelInfo,
  id,
  updateAssessmentLevel,
  history,
  getAssessmentLevelList,
  getSingleAssessmentLevel,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    ...form,
    ordinance_revision_id: ordinanceRevisionId,
  });
  const [dynamicFields, setDynamicFields] = useState([]);

  const validateForm = useFormValidator(formData, {
    actual_use_id: 'required',
    assessment_level: 'required',
    ordinance_revision_id: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!_.get(formData, 'actual_use_id')) {
      Alert.warning('Land Classification is required');
      return;
    }

    if (type === 'NEW') {
      createAssessmentLevel(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getAssessmentLevelList({
          ordinance_revision_id: ordinanceRevisionId,
        });
        history.push(
          `/rpt/land/land-settings/assessment-level/${data.data.id}`
        );
        getSingleAssessmentLevel(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateAssessmentLevel(id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getAssessmentLevelList({
          ordinance_revision_id: ordinanceRevisionId,
        });
        history.push(
          `/rpt/land/land-settings/assessment-level/${data.data.id}`
        );
        getSingleAssessmentLevel(data.data.id);
      });
    }
  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key, label) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
      [label]: e.label,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    getActualUseList({ status: 1 });
    getOrdinanceRevisionList();
  }, []);

  useEffect(() => {
    if (type === 'EDIT') {
      getActualUseList();
      setFormData({
        ...formData,
        actual_use_id: +_.get(assessmentLevelInfo, 'actual_use_id'),
        assessment_level: _.get(assessmentLevelInfo, 'assessment_level'),
        ordinance_revision_id: _.get(
          assessmentLevelInfo,
          'ordinance_revision_id'
        ),
      });
    }
  }, []);

  const landClassificationsOptions = actualUseList.map((x) => {
    return {
      value: x.id,
      fullInfo: x,
      label: _.get(x, 'attributes.name'),
    };
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="text-muted">
              Actual Use {validateForm.renderMessage('actual_use_id')}
            </label>
            <Select
              isDisabled={_.isEmpty(landClassificationsOptions)}
              value={
                landClassificationsOptions.find(
                  (item) =>
                    +_.get(formData, 'actual_use_id') === +_.get(item, 'value')
                ) || ''
              }
              onChange={handleOnChangeSelect('actual_use_id')}
              options={landClassificationsOptions}
              placeholder="Select actual use"
              components={{
                IndicatorSeparator: () => null,
              }}
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <div className="col-12 form-group">
            <label className="text-muted">
              Assessment Level {validateForm.renderMessage('assessment_level')}
            </label>
            <input
              className="form-control"
              type="number"
              autoFocus
              autoComplete="none"
              name="assessment_level"
              id="assessment_level"
              onChange={handleOnChange('assessment_level')}
              value={_.get(formData, 'assessment_level') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <div>
              <Select
                options={createDropdown(ordinanceRevisionList)}
                styles={customStyle}
                placeholder="Select Ordinance"
                value={
                  createDropdown(ordinanceRevisionList).filter(
                    (item) =>
                      +_.get(formData, 'ordinance_revision_id') ===
                      +_.get(item, 'value')
                  ) || ''
                }
                onChange={(e) => {
                  handleOrdinanceSelect(e);
                }}
                isDisabled
                formatOptionLabel={onRenderOption}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4">
          <button
            type="submit"
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 cms-bg-color-primary"
            disabled={!validateForm.response.is_passed}
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleOnClose}
            className="btn btn-light ml-1"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AssessmentLevelModal.defaultProps = {
  type: '',
  assessmentLevelInfo: {},
};

AssessmentLevelModal.propTypes = {
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  createAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  updateAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  history: PropTypes.instanceOf(Object).isRequired,
  assessmentLevelInfo: PropTypes.instanceOf(Object),
  id: PropTypes.string.isRequired,
  getAssessmentLevelList: PropTypes.instanceOf(Function).isRequired,
  getSingleAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelModal);
